/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckPitchSimpleRequest } from './deck-pitch-simple-request';
import { UserRequest } from './user-request';

/**
 * General serializer for Analysis model
 */
export interface DeckAnalysisRequest {
  user: UserRequest;
  pitch: DeckPitchSimpleRequest;
  title: string;
  text: string;
  muted?: boolean;
}
